import React, {useContext, useState, createContext} from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'

export type IAlertContext = {
    successAlert: (msg: string) => void
    warningAlert: (msg: string) => void
    errorAlert: (msg: string) => void
}

const AlertContext = createContext<IAlertContext>({
    successAlert: (msg) => {},
    warningAlert: (msg) => {},
    errorAlert: (msg) => {}
})

const useAlert = () => useContext(AlertContext)



function AlertProvider({children, ...props}) {
    const [alert, setAlert] = useState({isOpen: false, message: '', type: null})

    const successAlert = (msg) => {
        setAlert({isOpen: true, message: msg, type: 'success'})
    }

    const warningAlert = (msg) => {
        setAlert({isOpen: true, message: msg, type: 'warning'})
    }

    const errorAlert = (msg) => {
        setAlert({isOpen: true, message: msg, type: 'error'})
    }

    const handleClose = () => {
        setAlert({isOpen: false, message: '', type: null})
    }

    return(
        <AlertContext.Provider value={{successAlert, warningAlert, errorAlert}}>
            {children}
            <Snackbar open={alert.isOpen} autoHideDuration={6000} onClose={handleClose} anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
                {alert.type && <MuiAlert elevation={0} variant="filled" severity={alert.type} >{alert.message}</MuiAlert>}
            </Snackbar>
        </AlertContext.Provider>
    )
}

export {
    AlertProvider,
    useAlert
}
